module.exports = __webpack_public_path__ + "img/trusted-content.441d4bdb.svg";